
<template>
    <StateSwitch :state="status">
        <template #default>
            <slot
                name="default"
                :event-content="eventContent"
            />
        </template>
    </StateSwitch>
</template>

<script setup lang="ts">
const { slug } = defineProps<{
    slug: string;
}>();

const requestPath = computed(() => `/v2.0/event-contents/${slug}`);

const { data, status, error } = await useAsyncFetchLaravel<{ data: EventContentDetailData }>(requestPath);

if (error.value) {
    throw createError({ statusCode: 500, statusMessage: JSON.stringify(error.value) });
}

if (!data.value?.data) {
    throw createError({ statusCode: 404, statusMessage: `Event Not Found using slug "${slug}"` });
}

const eventContent = computed(() => data.value?.data);
</script>
